// 格式化日期 yyyy-MM-dd
let dateFormat = value => {
  if (!value) return ''
  let date = new Date(value)
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let day = date.getDate()
  return year + '-' + (month > 9 ? month : '0' + month) + '-' + (day > 9 ? day : '0' + day)
}

// 格式化时间 yyyy-MM-dd hh:mm:ss
let timeFormat = value => {
  if (!value) return ''
  let date = new Date(value)
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let day = date.getDate()
  let hour = date.getHours()
  let minute = date.getMinutes()
  let second = date.getSeconds()
  let time = (hour > 9 ? hour : '0' + hour) + ':' + (minute > 9 ? minute : '0' + minute) + ':' + (second > 9 ? second : '0' + second)
  return year + '-' + (month > 9 ? month : '0' + month) + '-' + (day > 9 ? day : '0' + day) + ' ' + time
}


let moneyFormat = value => {
  let prefix = "HK$";
  let prefixLen = prefix.length;
  let moneyStr;
  let moneyEnd;
  if(typeof(value) == "number"){
    moneyStr = value.toLocaleString('en-US');
  }else{
    moneyStr = value.substring(0,prefixLen) + parseFloat(value.substring(prefixLen)).toLocaleString('en-US');
  }
  // if(moneyStr.indexOf(".") < 0) {
  //   moneyStr = moneyStr + ".00";
  // }
  // moneyEnd = moneyStr.split(".")[1];
  // if(moneyEnd.length == 1){
  //   moneyStr = moneyStr+"0";
  // }
  return moneyStr;
}

export { dateFormat, timeFormat, moneyFormat }



// WEBPACK FOOTER //
// ./src/filters/index.js